import { useTranslation } from 'react-i18next';
import { useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { Url, URLS } from '@wix/da-url';
import { BiData } from '@wix/da-bi/pkg/events';
import { UserMenuContext } from '../UserMenuMobile/UserMenuContext';
export function useEarningsItem() {
    const { t } = useTranslation();
    const { isOpen: isUserMenuOpen } = useContext(UserMenuContext);
    const isMobile = useContext(MobileContext);
    return {
        label: t('siteHeader.userMenu.myEarnings'),
        link: Url.buildFromPath(URLS.EARNINGS),
        biData: BiData({
            evid: 702,
            link_url: Url.buildFromPath(URLS.EARNINGS),
            menu_item: isMobile ? 'myEarnings' : 'earnings',
            menu_name: 'profile'
        }),
        tabIndex: isUserMenuOpen || !isMobile ? 0 : -1
    };
}

//# sourceMappingURL=useEarningsItem.js.map